export default "__VITE_ASSET__CLIsgSV___"